import { StyledContainer } from './Container.Styled.js'

const Container = ({ children, className }) => {
  return <StyledContainer className={className}>{children}</StyledContainer>
}

export default Container
